import { render, staticRenderFns } from "./block-templates-card.vue?vue&type=template&id=2428169c&lang=pug"
import script from "./block-templates-card.vue?vue&type=script&lang=js"
export * from "./block-templates-card.vue?vue&type=script&lang=js"
import style0 from "./block-templates-card.vue?vue&type=style&index=0&id=2428169c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports